import { useT } from "@transifex/react";

/**
 * Holds the place of a gap the student never filled: inline in a sentence, an empty gap would collapse.
 * Visual only — StudentResultAnswerStateLabel announces the state.
 */
const StudentResultNoAnswerPlaceholder = () => {
    const t = useT();
    const t_noAnswer = t("<< no answer >>", { _tags: "StudentResult, NoAnswerPlaceholder" });

    return <span aria-hidden="true">{t_noAnswer}</span>;
};

export default StudentResultNoAnswerPlaceholder;
